module.exports = __webpack_public_path__ + "img/817.e5334f78.png";